// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getAddressFromAutoCompleteSuggestion = async (suggestion: any) => {
  const place = suggestion.placePrediction.toPlace();
  await place.fetchFields({ fields: ['addressComponents'] });

  const addressComponents = place.addressComponents as {
    types: string[];
    longText: string;
    shortText: string;
  }[];

  if (addressComponents) {
    let streetAddress = '';
    const streetNumber = addressComponents.find(obj => obj.types.includes('street_number'));
    const streetName = addressComponents.find(obj => obj.types.includes('route'));
    const city = addressComponents.find(obj => obj.types.includes('locality'))?.longText;
    const region = addressComponents.find(obj => obj.types.includes('administrative_area_level_1'))?.shortText;
    const postalCode = addressComponents.find(obj => obj.types.includes('postal_code'))?.longText;

    if (streetNumber) streetAddress += streetNumber.longText + ' ';
    if (streetName) streetAddress += streetName.shortText;

    return { streetAddress, city, region, postalCode };
  }

  return null;
};
